import { toast, ToastOptions } from 'react-toastify'

export function toastfy(type: string, content: string, theme?: string, options?: ToastOptions ) {
    const defaultOptions: ToastOptions = {
        position: 'top-right',
        autoClose: 3500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored'
    };
    const mergedOptions = { ...defaultOptions, ...options };
    
    switch (type) {
        case 'success':
            toast.success(content, mergedOptions)
            break;
        case 'warning':
            toast.warning(content, mergedOptions)
            break;
        case 'error':
            toast.error(content, mergedOptions)
            break;
        default:
            toast(content, mergedOptions)
    }

    return null;
}